/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import MyGroups from './MyGroups/MyGroups.redux';
import FindGroup from './FindGroup/FindGroup.redux';
import { JoinGroup } from './JoinGroup/JoinGroup';
import GroupDetails from './GroupDetails/GroupDetails.redux';

import RouteNames from '../../RouteNames';
import { IntendedGroup } from './JoinGroup/IntendedGroup';
import { SurveyIntro } from '../../../views/groupSurvey/SurveyIntro';
import { SurveyQuestion } from '../../../views/groupSurvey/SurveyQuestion/SurveyQuestion';
import { SurveyReview } from '../../../views/groupSurvey/SurveyReview';
import { SurveyComplete } from '../../../views/groupSurvey/SurveyComplete';
import { SurveySubmitted } from '../../../views/groupSurvey/SurveySubmitted';

const Groups = () => (
  <Switch>
    <Route exact path={RouteNames.myGroups()} component={MyGroups} />
    <Route exact path={RouteNames.intendedGroup()} component={IntendedGroup} />
    <Route exact path={RouteNames.findGroup()} component={FindGroup} />
    <Route exact path={RouteNames.joinGroup()} component={JoinGroup} />
    <Route exact path={RouteNames.surveyIntro()} component={SurveyIntro} />
    <Route exact path={RouteNames.surveyReview()} component={SurveyReview} />
    <Route exact path={RouteNames.surveyFirstQuestion()} component={SurveyQuestion} />
    <Route exact path={RouteNames.surveyLastQuestion()} component={SurveyQuestion} />
    <Route exact path={RouteNames.surveySubmitted()} component={SurveySubmitted} />
    <Route exact path={RouteNames.surveyComplete()} component={SurveyComplete} />
    <Route path={RouteNames.myGroupInfo()} component={GroupDetails} />

    <Route path="/" component={MyGroups} />
  </Switch>
);

export default Groups;
